import React, { forwardRef } from 'react';

import IconWithTooltip from "shared/react_components/IconWithTooltip";

import {
  userMentionSuggestion,
  userMentionSuggestionName,
  userMentionSuggestionEmail,
  colorBlue10,
  colorUIBlack10
} from "./styles/MentionSuggestions.module.scss";

// backgroundColor can't be added as classname otherwise it messes with focusing

// this needs to be a function for forwardRef, and therefore cannot have propTypes
// eslint-disable-next-line react/prop-types
function UserMentionSuggestion({ display, focused, email, role }, ref) {
  const filteredRole = role === "Filtered";
  const defaultBackgroundColor = filteredRole ? colorUIBlack10 : "white";
  const backgroundColor = focused ? colorBlue10 : defaultBackgroundColor;
  return (
    <div
      ref={ref}
      className={userMentionSuggestion}
      style={{ backgroundColor: backgroundColor }}
      data-test-id="user-mention-suggestion-container"
    >
      <div>
        <div className={userMentionSuggestionName}>
          {display}
        </div>
        <div className={userMentionSuggestionEmail}>
          {email}
        </div>
      </div>

      {filteredRole &&
        <IconWithTooltip icon="warning" className="text-warning" placement="top">
          Based on this user’s role, they may not be able to access this data.
        </IconWithTooltip>
      }
    </div>
  );
}
// eslint-enable-next-line react/prop-types

export default forwardRef(UserMentionSuggestion);
